import { useCallback } from 'react';
import {
  Button,
  Form,
} from '@skyline-platform/alchemy';
import Box from '@mui/material/Box';

export const ResultsForm = (properties) => {
  const {
    handleDownloadFiles,
    handleCloseModal,
    totalSuccessCount,
    totalErrorCount,
    totalRowCount,
    filename,
    downloadButtonState,
  } = properties ?? {};
  const pluralize = useCallback(
    (value, one, two) => {
      if (value === 1) {
        return one;
      }
      return two;
    },
    []
  );
  return (
    <Form
      formTitle='results-and-download'
      footer={[
        <>
          <Button
            iconLeft='fa-sharp fa-solid fa-file-csv'
            label='DOWNLOAD FULL RESULTS'
            handleClick={handleDownloadFiles}
            state={downloadButtonState}
            type='text'
          />
          <Button
            label='OK'
            handleClick={handleCloseModal}
            type='filled'
          />
        </>,
      ]}
    >
      {totalRowCount === totalSuccessCount && <Box className='success report'>
        <article className='centered-report'>
          <span className='filename'>{filename}</span> with {totalSuccessCount}&nbsp;
          {pluralize(totalSuccessCount, 'record', 'records')} has been successfully uploaded.
        </article>
      </Box>}
      {totalRowCount > totalSuccessCount && <Box className='success report'>
        <article className='centered-report'>
          {totalSuccessCount} {pluralize(totalSuccessCount, 'record', 'records')}&nbsp;
          within <span className='filename'>{filename}</span>&nbsp;
          {pluralize(totalSuccessCount, 'has', 'have')} been imported.
        </article>
      </Box>}
      {totalErrorCount > 0 &&
        <Box className='error report'>
          <article className='centered-report error'>
            {totalErrorCount} {pluralize(totalErrorCount, 'record', 'records')}&nbsp;
            {pluralize(totalErrorCount, 'has', 'have')} not been imported.
          </article>
        </Box>}
    </Form>
  );
};